<template>
  <div
    class="ts-border ts-p-3 ts-rounded ts-overflow-y-scroll"
    style="max-height: 450px; min-height: 250px"
  >
    <table class="ts-w-full ts-mt-2">
      <thead>
        <tr class="ts-bg-gray-200 ts-sticky ts-top-0 ts-z-50">
          <th class="ts-whitespace-no-wrap ts-py-2 ts-px-2">
            {{ $t('customerProfile.barcode') }}
          </th>
          <th class="ts-whitespace-no-wrap ts-py-2 ts-px-2">
            {{ $t('customerProfile.productName') }}
          </th>
          <th class="ts-whitespace-no-wrap ts-py-2 ts-px-2">
            {{ $t('customerProfile.uom') }}
          </th>
          <th class="ts-whitespace-no-wrap ts-py-2 ts-px-2">
            {{ $t('customerProfile.discountType') }}
          </th>
          <th class="ts-whitespace-no-wrap ts-py-2 ts-px-2">
            {{ $t('customerProfile.discount') }}
          </th>
          <th class="ts-text-center ts-py-2 ts-px-2">
            <a
              href="#"
              @click.prevent="() => (show_modal = true)"
              v-if="!model.is_discount_all_product"
            >
              <i class="fa fa-plus"></i>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(detail, index) in model.item_list">
          <tr :key="index">
            <td>
              <input
                type="text"
                :value="findProduct(detail.product_id).barcode"
                class="ts-py-1 ts-px-2 ts-w-full ts-outline-none"
                readonly
              />
            </td>
            <td>
              <input
                type="text"
                :value="findProduct(detail.product_id).product_name_en"
                class="ts-py-1 ts-px-2 ts-w-full ts-outline-none"
                readonly
              />
            </td>
            <td class="ts-py-2 ts-px-2 ts-w-24">
              <a-select
                @keydown.native.enter="onUomEnter(index)"
                v-model="detail.uom_id"
                class="ts-w-full"
                ref="uom"
                :showArrow="false"
                :class="{
                  'is-invalid': errors.has('item_list.' + index + '.uom_id'),
                }"
                @change="onUomChange(detail)"
              >
                <a-select-option
                  v-for="(u, index) in getUom(detail.product_id)"
                  :key="index"
                  :value="u.uom_id"
                  >{{ u.uom_name_en }}
                </a-select-option>
              </a-select>
            </td>
            <td class="ts-py-2 ts-px-2">
              <a-select
                v-model="detail.discount_type"
                class="ts-w-full"
                ref="uom"
                :class="{
                  'is-invalid': errors.has(
                    'item_list.' + index + '.discount_type'
                  ),
                }"
              >
                <a-select-option value="%">%</a-select-option>
                <a-select-option value="$">$</a-select-option>
              </a-select>
            </td>
            <td class="ts-py-2 ts-px-2">
              <input
                v-model.number.trim="detail.discout_rate"
                type="number"
                class="form-control"
                :class="{
                  'is-invalid': errors.has(
                    'item_list.' + index + '.discout_rate'
                  ),
                }"
                @keypress.enter="onDiscountEnter(index)"
              />
              <!-- <div
                class="validate"
                v-if="errors.has('item_list.' + index + '.discout_rate')"
              >
                {{ errors.first('item_list.' + index + '.discout_rate') }}
              </div> -->
            </td>
            <td class="ts-text-center" valign="middle">
              <a
                href="#"
                class="ts-text-red-600 ts-my-auto"
                @click.prevent="removeRow(detail)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <a-modal
      v-if="show_modal"
      v-model="show_modal"
      :title="$t('quotation.productList')"
      :footer="null"
      :zIndex="1022"
      :maskClosable="false"
      :centered="true"
    >
      <ProductList v-model="model" />
    </a-modal>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import ProductList from './product-list.vue'

export default {
  name: 'ItemDetails',
  props: ['value', 'validate'],
  components: {
    ProductList,
  },
  data() {
    return {
      errors: new Errors(),
      show_modal: false,
      model: {},
      newRow: {
        product_id: '',
        uom_id: '',
        discount_type: '%',
        discout_rate: 0,
      },
    }
  },
  computed: {
    ...mapState('customer/profile', ['edit_data']),
    ...mapGetters('customer/profile', [
      'getProduct',
      'getUom',
      'isDefaultUom',
      'getSalePrice',
      'getSpecification',
      'findProduct',
    ]),
    isNotEdit() {
      return this.edit_data.length > 0 || _.isEmpty(this.edit_data)
    },
  },
  created() {
    this.model = this.value
  },
  methods: {
    addNewRow() {
      this.model.item_list.push(_.clone(this.newRow))
    },
    removeRow(row) {
      this.model.item_list.splice(this.model.item_list.indexOf(row), 1)
    },
    onUomChange(row) {
      row.unit_price = this.getSalePrice({
        product_id: row.product_id,
        uom_id: row.uom_id,
      })
    },
    onUomEnter(index) {
      this.addNewRow()
      this.$nextTick(() => {
        this.$refs.product[index + 1].focus()
      })
    },
    onDiscountEnter(index) {
      this.addNewRow()
      this.$nextTick(() => {
        this.$refs.product[index + 1].focus()
      })
    },
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>